import { useState } from "react";
import { Search, X } from "lucide-react";
import T from "../theme/colors";

export default function SearchBar({ value, onChange, placeholder = "Search..." }) {
  const [focused, setFocused] = useState(false);
  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 7,
      background: "var(--bg-input)",
      border: `1px solid ${focused ? "var(--border-focus)" : "var(--border)"}`,
      borderRadius: 7, padding: "0 10px",
      minWidth: 220, transition: "border-color 0.15s, box-shadow 0.15s",
      boxShadow: focused ? `0 0 0 3px var(--primary-dim)` : "var(--shadow-sm)",
    }}>
      <Search size={13} style={{ color: focused ? "var(--primary)" : "var(--text-2)", flexShrink: 0, transition: "color 0.15s" }} />
      <input
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          background: "none", border: "none", color: "var(--text-0)",
          fontSize: 15, flex: 1, padding: "7px 0",
          fontFamily: "var(--font-ui)",
        }}
      />
      {value && (
        <button onClick={() => onChange("")} style={{
          background: "none", border: "none", color: "var(--text-2)", cursor: "pointer",
          display: "flex", padding: 2, borderRadius: 4,
        }}>
          <X size={12} />
        </button>
      )}
    </div>
  );
}
